import { Gift } from "lucide-react";

export function FreeBanner({ className = "" }) {
  return (
    <div data-testid="free-period-banner"
      className={`flex items-center gap-2 bg-green-50 border border-green-300 text-green-800 rounded-md px-4 py-3 text-sm font-semibold ${className}`}>
      <Gift className="w-5 h-5 shrink-0 text-green-600" />
      Gratis voor iedereen tot 31 december 2026 — alle functies, geen abonnement nodig.
    </div>
  );
}
